<dx-scroll-view height="100%" [useNative]="false" [showScrollbar]="'always'">
  <dx-form
    [(formData)]="associationFormData"
    labelMode="floating"
    [validationGroup]="validationGroup"
  >
    <dxi-item>
      <div *dxTemplate>
        <ag-shr-t-shirt-sizes-form
          [formData]="associationFormData?.[AssociationKeys.tShirtSizes]"
          [validationGroup]="validationGroup"
          [tShirtNote]="'Note: T-shirts are unisex.'"
          [isReverseOrder]="true"
          layout="horizontal"
        ></ag-shr-t-shirt-sizes-form>
      </div>
    </dxi-item>
  </dx-form>
</dx-scroll-view>
